import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { Environment } from '@playq/octopus-common';
import { ClusterizationRun, ClusterizationTaskId } from '@playq/services-beetle';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const retrieveLatestRunKeys = ['retrieve', 'latest', 'run'];
export const useRetrieveLatestRun = (
  taskId: ClusterizationTaskId,
  env: Environment = Environment.Live,
  options?: IUseQueryOptionsExtended<ClusterizationRun | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => retrieveLatestRunKeys.concat(taskId.serialize(), env), [env, taskId]);

  const res = useEitherQuery(
    keys,
    () => services2.audienceRequestsClusterizationService.retrieveLatestRun(taskId, env),
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  return { ...res };
};
